/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 订单列表
 * @param data
 * @returns {*}
 */
export function getOrderList(data) {
  return request.post("/saleOrder/list", data);
}

/**
 * 订单详情
 * @param data
 * @returns {*}
 */
export function getOrderDetal(data) {
  return request.post("/saleOrder/detail", data, { login: false });
}

/**
 * 订单详情
 * @param data
 * @returns {*}
 */
export function getOrderAdminShow(data) {
  return request.post("/saleOrder/adminshow", data, { login: false });
}
/**
 * 退货单详情
 * @param data
 * @returns {*}
 */
export function getSaleAdminShow(data) {
  return request.post("/saleAfter/adminshow", data, { login: false });
}
/**
 * 打印发货单详情
 * @param data
 * @returns {*}
 */
export function getPrintAdminShow(data) {
  return request.post("/saleOrderShip/adminshow", data, { login: false });
}

/**
 * 退货单打印详情
 * @param data
 * @returns {*}
 */
export function getThOrderPrint(data) {
  return request.post("/saleAfter/adminshow", data, { login: false });
}
/**
 * 获取发货单物流详情
 * @returns {*}
 */
export function getShipExpress(id) {
  return request.post("/sale/order/ship/express", { id });
}
/**
 * 获取支付信息
 * @param data
 * @returns {*}
 */
export function getPayInfo(id) {
  return request.post("/saleOrder/wechatPay", { id });
}
/**
 * 订单列表统计
 * @returns {*}
 */
export function getOrderStatistics() {
  return request.post("/saleOrder/statistics");
}

/**
 * 客户确认订单
 * @param orderId
 * @returns {*}
 */
export function confirmOrder(orderId) {
  return request.post("/saleOrder/confirm", {
    orderId
  });
}
/**
 * 客户绑定申请
 * @param customer_id
 * @returns {*}
 */
export function bindCustomer(customer_id) {
  return request.post("/userBind/bindCustomer", {
    customer_id
  });
}

/**
 * 客户绑定申请信息获取
 * @param customer_id
 * @returns {*}
 */
export function getCustomerInfo(customer_id) {
  return request.get("/userBind/getCustomerInfo", {
    customer_id
  });
}

/**
 * 客户地址绑定申请
 * @param addr_id
 * @returns {*}
 */
export function bindAddress(addr_id) {
  return request.post("/userBind/bindAddr", {
    addr_id
  });
}

/**
 * 客户绑定地址申请信息获取
 * @param addr_id
 * @returns {*}
 */
export function getAddressInfo(addr_id) {
  return request.get("/userBind/getCustomerAddrInfo", {
    addr_id
  });
}

/**
 * 个人中心地址信息
 * @param
 * @returns {*}
 */
export function getUserAddress() {
  return request.get("/userBind/customerAddrList");
}

/**
 * 获取发货单列表
 * @param data
 * @returns {*}
 */
export function getDispatchList(data) {
  return request.post("/fhd/list", data);
}

/**
 * 获取发货单统计
 * @param orderShipId
 * @returns {*}
 */
export function getDispatchStatistics() {
  return request.post("/fhd/statistics");
}

/**
 * 获取发货单详情
 * @param orderShipId
 * @returns {*}
 */
export function getDispatchDetail(id) {
  return request.post("/fhd/detail", {
    id
  });
}

/**
 * 获取售后单列表
 * @param data
 * @returns {*}
 */
export function getServiceList(data) {
  return request.post("/saleOrderAfter/list", data);
}

/**
 * 获取售后单列表统计
 * @returns {*}
 */
export function getServiceStatistics() {
  return request.post("/saleOrderAfter/statistics");
}

/**
 * 获取售后单详情
 * @param data
 * @returns {*}
 */
export function getServiceDetail(data) {
  return request.post("/saleOrderAfter/detail", data);
}

/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(cartId) {
  return request.post("/order/confirm", {
    cartId
  });
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(key, data) {
  return request.post("/order/computed/" + key, data);
}

/**
 * 获取指定金额可用优惠券
 * @param price
 * @returns {*}
 */
export function getOrderCoupon(price, data) {
  return request.get("/coupons/order/" + (parseFloat(price) || 0), data);
}

/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(key, data) {
  return request.post("/order/create/" + key, data || {});
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
  return request.get("/order/data");
}

// /**
//  * 订单列表
//  * @returns {*}
//  */
// export function getOrderList(data) {
//   return request.get("/order/list", data);
// }

/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(id) {
  return request.post("/order/cancel", {
    id
  });
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(id) {
  return request.get("/order/detail/" + id);
}

/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/order/refund/reason");
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/order/take", {
    uni
  });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", {
    uni
  });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(uni, paytype, from) {
  return request.post("order/pay", {
    uni,
    paytype,
    from
  });
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("order/order_verific", {
    verify_code,
    is_confirm
  });
}
/**
 * 再次下单
 * @param string uni
 *
 */
export function orderAgain(uni) {
  return request.post("order/again", {
    uni: uni
  });
}
